import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';

import { SafePipe } from './safe.pipe';
import { ShortNotePipe } from './short-note.pipe';

@NgModule({
  declarations: [SafePipe, ShortNotePipe],
  exports: [ButtonModule, DropdownModule, InputTextModule, SafePipe, ShortNotePipe],
  imports: [ButtonModule, CommonModule, DropdownModule, InputTextModule],
})
export class SharedModule {}
